import { render } from "./Projets.vue?vue&type=template&id=0aace15e&scoped=true"
import script from "./Projets.vue?vue&type=script&lang=js"
export * from "./Projets.vue?vue&type=script&lang=js"

import "./Projets.vue?vue&type=style&index=0&id=0aace15e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0aace15e"]])

export default __exports__